module.exports = __webpack_public_path__ + "img/054.b49bbb9d.png";